/* eslint-disable max-len */
import type { FunctionComponent } from 'react';
import { type PageContextType, usePage } from '../../../contexts/PageContext';
import { type RebrandingContextProps, useRebranding } from '../../../contexts/RebrandingContext';
import { PlatformsId } from '../../../../services/types';

const EmailValidationMP: FunctionComponent = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#009EE3" d="M23.25 5.25v13.5H.75V5.25h22.5zm-1.5 3.544l-7.89 4.507c-1.153.659-2.567.659-3.72 0L2.25 8.795v8.455h19.5V8.794zm0-2.044H2.25v.316l8.634 4.933c.638.364 1.41.392 2.07.084l.162-.084 8.634-4.934V6.75z" />
  </svg>
);

const EmailValidationCongratsMP: FunctionComponent = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M0.75 5.25H23.25V18.75H0.75V5.25ZM2.25 8.79417V17.25H21.75V8.79417L13.8601 13.3012C12.7074 13.9596 11.2926 13.9596 10.1399 13.3012L2.25 8.79417ZM2.25 7.06669L10.884 11.9987C11.5755 12.3938 12.4245 12.3938 13.116 11.9987L21.75 7.06669V6.75H2.25V7.06669Z" fill="#00A650" />
  </svg>
);

const EmailValidationML: FunctionComponent = () => (
  <svg width="24px" height="16px" viewBox="0 0 24 16" version="1.1" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <title>Thumbnail</title>
    <defs>
      <rect id="path-1" x="0" y="0" width="344" height="85" rx="6" />
      <filter x="-7.8%" y="-24.7%" width="115.7%" height="163.5%" filterUnits="objectBoundingBox" id="filter-2">
        <feOffset dx="0" dy="6" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="8" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0" type="matrix" in="shadowBlurOuter1" />
      </filter>
      <circle id="path-3" cx="20" cy="20" r="20" />
    </defs>
    <g id="Registro-ML---nativo-" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="HUB---Validación-de-e-mail" transform="translate(-28.000000, -205.000000)">
        <rect fill="#FFFFFF" x="0" y="0" width="360" height="640" />
        <g id="Group" transform="translate(8.000000, 179.000000)">
          <g id="🔲-Shadow-style">
            <use fill="black" fillOpacity="1" filter="url(#filter-2)" xlinkHref="#path-1" />
            <use fill="#FFFFFF" fillRule="evenodd" xlinkHref="#path-1" />
          </g>
          <g id="02-Medium-/-01-Simple-/-With-Thumbnail-+-Text-+-Description" transform="translate(12.000000, 0.000000)">
            <g id="Thumbnail" transform="translate(0.000000, 14.000000)">
              <g id="Thumbnail-state">
                <g id="一-/-Thumbnail-/-BG-/-ICON-Default">
                  <mask id="mask-4" fill="white">
                    <use xlinkHref="#path-3" />
                  </mask>
                  <circle strokeOpacity="0.0700000003" stroke="#000000" cx="20" cy="20" r="19.5" />
                </g>
                <g id="Group" transform="translate(8.000000, 8.000000)" fill="#3483FA" fillRule="nonzero">
                  <g id="🖼Icon">
                    <path d="M23.25,4.546797 L23.25,19.4798466 L0.75,19.4798466 L0.75,4.546797 L23.25,4.546797 Z M21.75,8.791797 L13.860521,13.3006585 C12.7754645,13.9206907 11.457949,13.9571632 10.3455444,13.4100759 L10.139479,13.3006585 L2.25,8.792797 L2.25,17.979 L21.75,17.979 L21.75,8.791797 Z M21.75,6.046 L2.25,6.046 L2.25,7.064797 L10.8836874,11.9982937 C11.5222014,12.3631589 12.294878,12.3912254 12.9540324,12.0824934 L13.1163126,11.9982937 L21.75,7.063797 L21.75,6.046 Z" id="Combined-Shape" />
                  </g>
                </g>
              </g>
              <g id="Badge-type" transform="translate(28.000000, 24.000000)" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const EmailValidationSVG: FunctionComponent = () => {
  const { platformId } = usePage() as PageContextType;
  const { isRebrandingEnabled } = useRebranding() as RebrandingContextProps;

  if (platformId === PlatformsId.MP) return isRebrandingEnabled ? <EmailValidationML /> : <EmailValidationMP />;

  return <EmailValidationML />;
};

export const EmailValidationCongratsSVG: FunctionComponent = () => {
  const { platformId } = usePage() as PageContextType;
  return (platformId === 'ML' || platformId === 'PI' || platformId === 'TC' || platformId === 'MT') ? <EmailValidationML /> : <EmailValidationCongratsMP />;
};
